module.exports = __webpack_public_path__ + "static/img/RWDA1565-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWDA1565-G_1.png
// module id = f8rd
// module chunks = 0